<!-- Translated: yes -->
<template>
  <Modal @close="closeModal" :wide="false">
    <h2 class="uppercase center" slot="header">{{ $t('skischool.explanation-title') }}</h2>
    <div class="items-list">
      <div class="item" v-for="{title, description, color, text} in infos">
        <div class="item-header">
           <span class="circle" :style="{ 'background-color': color }"></span>
           <span class="title" :style="{ 'color': color }">{{ title }}</span><span class="description">— {{ description }}</span>
        </div>
        <div class="item-body">
          {{ text }}
        </div>
      </div>
    </div>

  </Modal>
</template>

<script>
import { mapMutations } from 'vuex';
import Modal from '@/components/components/Modal';

export default {
  components: {
    Modal,
  },
  mounted() {
    for (let i in this.infos) { // eslint-disable-line
      this.infos[i].title = this.$i18n.t('skischool.levels.' + this.infos[i].level); // eslint-disable-line
    } // eslint-disable-line
  },
  data() {
    return {
      expanded: [],
      infos: [
        {
          color: '#559761',
          title: '',
          description: '',
          text: '',
          level: 'green',
        },
        {
          color: 'rgba(0, 85, 128, 0.92)',
          title: '',
          description: '',
          text: '',
          level: 'blue',
        },
        {
          color: '#ae1116',
          title: '',
          description: '',
          text: '',
          level: 'red',
        },
        {
          color: '#262626',
          title: '',
          description: '',
          text: '',
          level: 'black',
        },
      ],
    };
  },
  methods: {
    ...mapMutations([
      'closeModal',
    ]),
    toggle(index) {
      if (this.expanded.includes(index)) {
        return this.expanded.pop(index);
      }
      return this.expanded.push(index);
    },
    isActive(index) {
      return this.expanded.includes(index);
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'
.circle
  width 15px
  height 15px
  background-color black
  border-radius 50%
  margin-right 5px
h2
  united-heavy()
  font-size: 24px

.items-list
  margin: 2em 0
.item
  padding: .5em 1em;
  margin-bottom: .5em;

  .item-header
    @extend .uppercase, .bold
    united-heavy()
    display: flex
    margin-bottom 15px
    // justify-content: space-between

    .title
      font-size 20px
    .description
      margin-left 5px
      font-family: Interstate
      letter-spacing: 0px
      font-weight: bold
      font-size: 12px
</style>



// WEBPACK FOOTER //
// SkiSchoolInfo.vue?2868280b